import React from "react";
import { AddToolTip } from "../../../components";

const AddSpecificationInformationContainer = ({
  specificationData,
  values,
  fields,
  setFieldValue,
}) => {
  return (
    <div className="w-100 cardDetails">
      <input
        style={{ marginLeft: "15px", marginTop: "-7px", outline: "none" }}
        type="radio"
        checked={specificationData.id == values?.feeSpecificationId}
        value={values[fields.feeSpecificationId]}
        onChange={() => {
          setFieldValue(fields.feeSpecificationId, specificationData.id);
        }}
        name="plan"
      />

      <div className="ml-3 mt-4" style={{ whiteSpace: "nowrap", width: "31%" }}>
        {specificationData?.name?.length < 30 ? (
          <div className="ft-14 fw-500">{specificationData?.name}</div>
        ) : (
          <>
            {specificationData?.name == null ? (
              <>{"-"}</>
            ) : (
              <>
                <AddToolTip
                  className="ft-14 fw-500"
                  name={specificationData?.name}
                >
                  {specificationData?.name.slice(0, 30)}...
                </AddToolTip>
              </>
            )}
          </>
        )}
      </div>

      <div className="mt-4" style={{ width: "38%" }}>
        {specificationData?.description?.length < 40 ? (
          <div className="ft-14 fw-500">{specificationData?.description}</div>
        ) : (
          <>
            {specificationData?.description == null ? (
              <>{"-"}</>
            ) : (
              <>
                <AddToolTip
                  className="ft-14 fw-500"
                  name={specificationData?.description}
                >
                  {specificationData?.description.slice(0, 40)}...
                </AddToolTip>
              </>
            )}
          </>
        )}
      </div>

      <div className="mt-4">
        {specificationData.allocationType == 1 ? (
          <div className="ft-14 fw-500">{"Fixed Amount"}</div>
        ) : specificationData.allocationType == 2 ? (
          <div className="ft-14 fw-500">{"Percentage/Basis Points"}</div>
        ) : (
          <div className="ft-14 fw-500">{"Tiered"}</div>
        )}
      </div>
    </div>
  );
};

export default AddSpecificationInformationContainer;
